import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Form } from "@ui/form/Form";
import { useState } from "react";
import { GD } from "src/GD";
import { S_AUTH_CHANGE_VIEW } from "./AuthSignals";
import { registrationForm, TAuthRegister } from "./RegisterView";

export const RegisterStep1 = () => {
	useLocale();
	const [formData, setFormData] = useState<TAuthRegister>(registrationForm.step1);

	const validate = (): boolean => {
		if (!registrationForm.step1.registration_number || registrationForm.step1.registration_number === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step1",
				error: {
					code: -1,
					message: msg("pleaseProvideRegistrationNumber"),
				},
			});
			return false;
		}
		if (!registrationForm.step1.company_name || registrationForm.step1.company_name === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step1",
				error: { code: -1, message: msg("pleaseEnterCompanyName") },
			});

			return false;
		}
		if (registrationForm.step1.country === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step1",
				error: { code: -1, message: msg("pleaseSelectCountry") },
			});
			return false;
		}
		return true;
	};

	const handleSubmit = async () => {
		if (validate()) {
			GD.REG_STEP_ERROR.invoke({
				step: "step1",
				error: null,
			});
			GD.REQ_STEP_BUSY.invoke(true);
			const response = await GD.REQ_API.request({
				method: "clients/precheck",
				data: {
					id: 0,
					project_id: 0,
					name: registrationForm.step1.company_name,
					country: registrationForm.step1.country,
					registration_number: registrationForm.step1.registration_number,
				},
			});
			GD.REQ_STEP_BUSY.invoke(false);

			if (response && response.data) S_AUTH_CHANGE_VIEW.invoke("reg2");
			else
				GD.REG_STEP_ERROR.invoke({
					step: "step1",
					error: response?.error ?? {
						code: -1,
						message: msg("unknownError"),
					},
				});
		}
	};

	return (
		<>
			{formData && (
				<Form
					sx={{ gap: "30px" }}
					data={formData}
					//error={saveResult}
					onSubmit={() => {
						/*resetSaveResult(null);
							save({ ...formData });*/
						handleSubmit();
					}}
					onChange={form => {
						registrationForm.step1 = form;
						setFormData(form);
					}}
					submitTitle="Continue"
					fullWidthButton
				/>
			)}
		</>
	);
};
